var map = {
	"./uxc-app-header.entry.js": [
		62143,
		"default-node_modules_trumpf_ux_application-framework_dist_esm_index-f448ce7a_js",
		"default-node_modules_trumpf_ux_application-framework_dist_esm_backend-d59be592_js",
		"common",
		"node_modules_trumpf_ux_application-framework_dist_esm_uxc-app-header_entry_js"
	],
	"./uxc-app-language-selector.entry.js": [
		60892,
		"default-node_modules_trumpf_ux_application-framework_dist_esm_index-f448ce7a_js",
		"node_modules_trumpf_ux_application-framework_dist_esm_uxc-app-language-selector_entry_js"
	],
	"./uxc-app-notification-list.entry.js": [
		18282,
		"default-node_modules_trumpf_ux_application-framework_dist_esm_index-f448ce7a_js",
		"default-node_modules_trumpf_ux_application-framework_dist_esm_backend-d59be592_js",
		"common",
		"node_modules_trumpf_ux_application-framework_dist_esm_uxc-app-notification-list_entry_js"
	],
	"./uxc-app-sidebar-notifications.entry.js": [
		74169,
		"node_modules_trumpf_ux_application-framework_dist_esm_uxc-app-sidebar-notifications_entry_js"
	],
	"./uxc-u-mytrumpf-notification-service.entry.js": [
		76390,
		"default-node_modules_trumpf_ux_application-framework_dist_esm_index-f448ce7a_js",
		"default-node_modules_trumpf_ux_application-framework_dist_esm_backend-d59be592_js",
		"node_modules_trumpf_ux_application-framework_dist_esm_uxc-u-mytrumpf-notification-service_entry_js"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 87387;
module.exports = webpackAsyncContext;